"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsFinancial_1 = require("../../model/hsFinancial");
var service_1 = require("../../../library/base/service");
var AccountInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AccountInfo, _super);
    function AccountInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的高端理财信息接口';
        _this.code = '105006';
        _this.desc = '我的高端理财信息接口';
        _this.requestParams = new hsFinancial_1.AccountInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return AccountInfo;
}(service_1.BaseService));
exports.AccountInfo = AccountInfo;
//# sourceMappingURL=accountInfo.js.map